import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";

import { log } from "utils/logger";

import "../css/TwitterShare.css";

export default function TwitterShare({ accuracy, wordCount }) {
  const text =
    "I can type " +
    wordCount +
    " crazy long words per minute 😤\nCan you do any better?" +
    "\n\n";

  return (
    <a
      className="tweet"
      href={
        "https://twitter.com/intent/tweet?text=" +
        encodeURI(text) +
        "&hashtags=longwordsperminute&url=" +
        window.location.href
      }
      target="_blank"
      rel="noreferrer"
      onClick={() => log("twitter_share_clicked")}
    >
      <FontAwesomeIcon icon={faTwitter} /> Share my score
    </a>
  );
}
